import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import {
    ResponsiveContainer,
    BarChart,
    CartesianGrid,
    XAxis,
    YAxis,
    Tooltip,
    Bar,
} from "recharts";

export default function ReactivePhase2EnergyBars({ deviceId, API_BASE }) {
    const { t } = useTranslation();
    const [data, setData] = useState([]);

    useEffect(() => {
        async function load() {
            try {
                const active = await (await fetch(`${API_BASE}/reactive/energy/active?deviceId=${deviceId}`)).json();
                const ind = await (await fetch(`${API_BASE}/reactive/energy/inductive?deviceId=${deviceId}`)).json();
                const cap = await (await fetch(`${API_BASE}/reactive/energy/capacitive?deviceId=${deviceId}`)).json();
                const va = await (await fetch(`${API_BASE}/reactive/energy/apparent?deviceId=${deviceId}`)).json();

                setData([
                    {
                        name: t('energies.activeImport'),
                        value: Math.trunc((active.EL2_IMPORT ?? 0) * 1000) / 1000,
                        unit: "kWh"
                    },
                    {
                        name: t('energies.activeExport'),
                        value: Math.trunc((active.EL2_EXPORT ?? 0) * 1000) / 1000,
                        unit: "kWh"
                    },
                    {
                        name: t('energies.inductive'),
                        value: Math.trunc((ind.EL2_END ?? 0) * 1000) / 1000,
                        unit: "kVArh"
                    },
                    {
                        name: t('energies.capacitive'),
                        value: Math.trunc((cap.EL2_CAP ?? 0) * 1000) / 1000,
                        unit: "kVArh"
                    },
                    {
                        name: t('energies.apparent'),
                        value: Math.trunc((va.EL2_VA ?? 0) * 1000) / 1000,
                        unit: "kVAh"
                    },
                ]);

            } catch (err) {
                console.error("Phase2Energy error:", err);
            }
        }

        load();
    }, [deviceId, API_BASE]);

    return (
        <div className="bg-white p-5 rounded-xl border border-slate-200 shadow">
            <h3 className="text-sm font-semibold text-slate-700 mb-3">
                {t('energies.phase2Energy')}
            </h3>

            {/* Grafik yüksekliği sabit, kart dışına taşmıyor */}
            <div className="w-full h-[330px]">
                <ResponsiveContainer width="100%" height="100%">
                    <BarChart
                        data={data}
                        margin={{ top: 20, right: 20, left: 0, bottom: 60 }}
                    >
                        <CartesianGrid strokeDasharray="3 3" />

                        <XAxis
                            dataKey="name"
                            interval={0}
                            tick={{
                                angle: -40,
                                textAnchor: "end",
                                fontSize: 11,
                            }}
                            height={50}
                        />

                        <YAxis tick={{ fontSize: 12 }} />

                        <Tooltip
                            formatter={(value, name, props) =>
                                [`${value} ${props.payload.unit || ""}`, props.payload.name]
                            }
                        />

                        <Bar dataKey="value" fill="#F97316" />
                    </BarChart>
                </ResponsiveContainer>
            </div>
        </div>
    );
}
